<h1 class="text-dark text-xl" mat-dialog-title>Nuova assicurazione</h1>
<div class="w-full" mat-dialog-content>
  <app-insurance-form
    [data]="newInsurance"
    [dialogRef]="dialogRef"
    [isNewForm]="true"
  ></app-insurance-form>
</div>
